module.exports = __webpack_public_path__ + "static/media/muscle_front_11.c77f413f.png";